import React, {useState} from "react";
import Link from "next/link";

const Weddings: React.FC = ({ children }) => {

  return(
    <>
<section id="venue-hero">
      <div className="cover-shape"></div>
      <div className="content-container maxw1350">
        <h1>TacBoard for Weddings</h1>
        <p>Your guests will love it and you will love all the photos</p>
        <Link href="/tacboard-pricing">
            <a className="get-tac-now">Get TacBoard Now</a>
        </Link>
      </div>
      <div className="bottom-wave"></div>
    </section>

    <section className="events-description">
      <div className="content-container">
        <h2>Set up TacBoard at your wedding and create easy and fun entertainment for your guests all while building an amazing album of candid photos from your wedding celebration.</h2>
      </div>
    </section>


<section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Oldies But Goodies<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
          <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-weddings-old.png" alt="TacBoard Weddings Old Couple Photos" />
          </picture>
        </div>
        <div className="half">
          <p>
          Add old photos to your gallery beforehand and have them already streaming on your Live Stream when the reception starts. These could be of the couple as kids or more recent photos of them having fun with their friends and family (who will likely be in attendance and will love seeing themselves with the celebrities of the day).
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

    <section className="includes">
      <h2 className="center">
        <span className="line"></span>Ask and You Shall Receive<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-weddings-sign.png" alt="TacBoard Weddings Photo Sign" />
          </picture>
        </div>
        <div className="half">       
        <p>
          Place some signs around at the rehearsal and reception asking guests to take specific photos, or selfies and text them to your TacBoard number.
          </p>
        </div>
      </div>
    </section>

<section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Making Photo Fun<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-weddings-photo-area.png" alt="TacBoard Weddings Photo Sign" />
          </picture>
        </div>
        <div className="half">      
        <p>
          Make a photo station at your reception with fun props and a sign asking guests to snap some fun pics and text them to your TacBoard phone number.
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

    <section className="includes">
      <h2 className="center">
        <span className="line"></span>Easy, Fun & Fabulous<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
          <video disableRemotePlayback className="thumb-vid" muted loop autoPlay preload="auto">
            <source src="img/av-live-screen.webm" type="video/webm" />
            <source src="img/av-live-screen.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="half">       
        <p>
          Your guests will love it. It is fun, interactive and easy without being dominating, distracting, or obnoxious.
          </p>
        </div>
      </div>
    </section>

<section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Surprises You'll Love<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
          <picture>
            {/* <source type="image/webp" srcSet="img/sign-shop-sign-selfie-station.webp
                        " />
            <source type="image/jpg" srcSet="img/sign-shop-sign-selfie-station.jpg
                    " /> */}

            <img src="img/dol-lp-home.png" alt="Collect hundreds of wedding photos with TacBoard" />
          </picture>
        </div>
        <div className="half">
          <p>
          You will seamlessly collect hundreds of candid pics from your big day that you may have never seen otherwise.
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>


    <section className="includes">
      <h2 className="center">
        <span className="line"></span>Now It's Time To Relax<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="img/sign-shop-sign-selfie-station.webp
                        " />
            <source type="image/jpg" srcSet="img/sign-shop-sign-selfie-station.jpg
                    " /> */}

            <img src="img/how-step4.png" alt="Relax and view your TacBoard Gallery" />
          </picture>
        </div>
        <div className="half">       
        <p>
          You will have a lot of wedding photos to look at on your honeymoon before waiting weeks for your professional photos to arrive.
          </p>
        </div>
      </div>
    </section>

<section className="events-description">
  <div className="content-container">
    <h2>Sign up and get TacBoard for your your Wedding!</h2>
  </div>
</section>

    </>
)}

export default Weddings;
